import React, { useState } from "react";
import Input from "@mui/material/Input";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

function highlightMatch(text, term) {
  if (!term) return text;
  const idx = text.toLowerCase().indexOf(term.toLowerCase());
  if (idx === -1) return text;
  return (
    <>
      {text.slice(0, idx)}
      <b>{text.slice(idx, idx + term.length)}</b>
      {text.slice(idx + term.length)}
    </>
  );
}

export default function SearchBarWithDropdown({ value, onChange, onSelect, results = [], getIcon, onEnter }) {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #ccc",
          borderRadius: "20px",
          background: "#f5f5f5",
          px: 2,
          py: 0.5,
          width: "100%",
        }}
      >
        <SearchIcon sx={{ color: "#666", mr: 1 }} />
        <Input
          value={value}
          onChange={e => {
            onChange(e.target.value);
            setShowDropdown(true);
          }}
          onFocus={() => setShowDropdown(true)}
          placeholder="Search"
          disableUnderline
          sx={{ flex: 1, fontSize: "14px", background: "transparent", height: "36px", color: "#333" }}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              setShowDropdown(false);
              onEnter && onEnter();
            }
          }}
        />
        {value && (
          <ClearIcon
            sx={{ cursor: "pointer", ml: 1 }}
            onClick={() => onChange("")}
          />
        )}
      </Box>
      {showDropdown && value && (
        <Paper
          sx={{
            position: "absolute",
            top: "44px",
            left: 0,
            right: 0,
            zIndex: 10,
            borderRadius: "12px",
            boxShadow: 3,
            maxHeight: 300,
            overflowY: "auto",
          }}
        >
          <List>
            {results.length === 0 ? (
              <ListItem> No results </ListItem>
            ) : (
              results.map((item, idx) => (
                <ListItem
                  button
                  key={item.unique_id || idx}
                  onClick={() => {
                    onSelect && onSelect(item);
                    setShowDropdown(false);
                  }}
                  sx={{ cursor: 'pointer' }}
                >
                  <ListItemIcon>{getIcon ? getIcon(item) : "📄"}</ListItemIcon>
                  <ListItemText 
                    primary={highlightMatch(item.name || item.title, value)}
                    secondary={item.path ? item.path.join(' / ') : undefined}
                  />
                </ListItem>
              ))
            )}
          </List>
        </Paper>
      )}
    </Box>
  );
} 